export const isObject = (value: any) => {
    const {isArray} = Array;
    return value !== null && !isArray(value) && typeof value === 'object';
};

export const mapToNull = (value: any) => {
    if (value === '')
        return null;
    
    return value;
};

export const trimValue = (value: any) => typeof value === 'string' ? value.trim() : value;

export const convertEmptyStringToNull = (params: any) => {
    const newParams = {};
    const keys = Object.keys(params);
    
    for (const key of keys) {
        if (isObject(params[key])) {
            // @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'strin... Remove this comment to see the full error message
            newParams[key] = convertEmptyStringToNull(params[key]);
            continue;
        }
        
        // @ts-expect-error ts-migrate(7053) FIXME: No index signature with a parameter of type 'strin... Remove this comment to see the full error message
        newParams[key] = mapToNull(trimValue(params[key]));
    }
    
    return newParams;
};
